export default __webpack_public_path__ + "static/media/ico-sq-7-energy.f2733c6c.svg";